import Roster_create from "@/pages/roster-create/Roster_create";
import { useRosterInitializer } from "@hooks/useRosterInitalizer.ts";
import { useRosterResources } from "@hooks/useRosterMetaresource.ts";
import { useLoginUser } from "@hooks/useAuth.ts";
import { useGroupStore } from "@store/groupStore.ts";
import ErrorComponent from "@components/ui/error.tsx";
import NoneConfigData from "../roster-config/components/none-configdata";
import { useInitializeGroup } from "@/hooks/useInitializeGroup";
import { useNavigate } from "react-router-dom";
import LoadingDots from "@/components/LoadingDots";

function RosterCreateView() {
  const loginUser = useLoginUser();
  const isAdmin = !!(
    loginUser?.EmpAuthGbn === "ADM" || loginUser?.is_master_admin
  );
  const { selectedGroupId } = useGroupStore();
  const gid = isAdmin ? (selectedGroupId ?? "") : "";

  // 날짜를 가져오고
  useRosterInitializer({ groupId: gid });

  // 버전 리스트는 Roster_create 내부에서 useRosterVersions로 가져오므로 여기서는 제거
  // useRosterVersions({ groupId: gid });

  // GroupId 기준으로 meta 데이터 설정
  const { isLoading, isError, data } = useRosterResources({ groupId: gid });
  if (isLoading) {
    return (
      <div className="rosterCreating">
        근무표를 불러오고 있습니다.
        <LoadingDots />
      </div>
    );
  }

  if (isError) {
    return <ErrorComponent />;
  }

  return <Roster_create />;
}

/**
 * 12/17 박현민
 * 캐싱을 레이어 순으로 해야함..
 *
 * 날짜를 먼저세팅 후 versions 가져와야함 - 캐싱
 *
 * useRosterResources는 Schedule version 기준으로 타겟 가져와야함 - versions 별 캐싱
 * 이는 병렬적으로 실행되어야함
 *
 * ----- 12/24 -----
 * 데이터를 전부 가져와서 랜딩하려했으나 내부에서 또 비동기를 핸들링하고 useEffect함 reffer 에러 날 확률이 있음
 * */

export default function RosterCreatePage() {
  const navigate = useNavigate();
  const loginUser = useLoginUser();

  const isAdmin = !!(
    loginUser?.EmpAuthGbn === "ADM" || loginUser?.is_master_admin
  );

  const { groups } = useInitializeGroup({
    loginUser,
    isAdmin,
    navigate,
  });

  // ADM이고 그룹 목록이 비어있는 경우: 안내 문구 표시
  if (isAdmin && Array.isArray(groups) && groups.length === 0) {
    return <NoneConfigData />;
  }

  return <RosterCreateView />;
}
